import { useEffect } from 'react';
import { css } from '@emotion/react';
import { Outlet, createFileRoute, useRouterState } from '@tanstack/react-router';
import { Loader } from '../../components/Loader';
import { Navbar } from '../../components/Navbar';
import { useIntegrationsDashboardShallowStore } from '../../store';

const PublicLayout = () => {
  const pathName = useRouterState({ select: (s) => s.location.pathname });
  const { isUserAuthenticated, resetState } = useIntegrationsDashboardShallowStore('isUserAuthenticated', 'resetState');

  useEffect(() => {
    resetState();
  }, []);

  return (
    <>
      {pathName !== '/sign-in' && pathName !== '/sign-in/callback' ? (
        <header css={headerStyle}>
          <Navbar isUserAuthenticated={isUserAuthenticated} />
        </header>
      ) : null}
      <main>
        <Outlet />
      </main>
    </>
  );
};

export const Route = createFileRoute('/_public')({
  pendingComponent: () => <Loader />,
  component: PublicLayout,
});

const headerStyle = css`
  position: sticky;
  top: 0;
  z-index: 100;
`;
